import { defaultHeaders, HttpMethod } from '../constants';
import { GetWorkflowResponseDefinition, UpdateWorkflowRequestDefinition } from '../types';
import { ApiConfig } from './types';

const WorkflowApi = ({ baseUrl, fetchWithToken }: ApiConfig) => {
  const url = `${baseUrl}/workflow`;
  return {
    get(): Promise<GetWorkflowResponseDefinition> {
      return fetchWithToken<GetWorkflowResponseDefinition>(url);
    },
    update(body: UpdateWorkflowRequestDefinition): Promise<GetWorkflowResponseDefinition> {
      return fetchWithToken<GetWorkflowResponseDefinition>(url, {
        method: HttpMethod.Patch,
        body: JSON.stringify(body),
        headers: defaultHeaders,
      });
    },
  };
};

export default WorkflowApi;
